<template>
  <v-row>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-tooltip v-if="mode=='update'" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="warning"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="mr-3"
                    >
                      warning
                    </v-icon>
                  </template>
                  <span>If you update a currently active program,
                        <span style="text-decoration: underline">only</span> workouts in
                        the future will be updated to match the new program
                        workouts.</span>
                </v-tooltip>
              <v-label>Changing from {{ currentProgramName }} to: </v-label>
            </v-col>
            <v-col cols="12">
              <validation-provider
                  v-slot="{ errors }"
                  name="newProgramId"
                  rules="required"
                >
                <v-autocomplete
                  v-model="newProgramId"
                  solo
                  clearable
                  :error-messages="errors"
                  :items="programOptions"
                ></v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12">
              <v-btn
                @click="close()"
                color="secondary"
                >
                Cancel
              </v-btn>
              <v-btn
                @click="changeCurrentProgram"
                :disabled="invalid"
                :loading="saving"
                class="float-right"
                >Apply Change</v-btn
              >
            </v-col>
            
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        
      </v-row>
    </validation-observer>
  </v-row>
</template>

<script>
import { UPDATE_USER_PROGRAM_MUTATION } from "../../../constants/graphql/user_program/user_program";
import { PROGRAMS_QUERY } from "@/constants/graphql/user_program/user_program";

export default {
  name: "UserProgramForm",
  props: ["mode", "programId", "currentProgramId", "currentProgramName"],
  data() { return {
      saving: false,
      selectedProgram: {},
      programs: [],
      programOptions: [],
      newProgramId: null,
    }
  },
  mounted() {
    this.newProgramId = this.currentProgramId;
  },
  methods: {
    close() {
      this.newProgramId = this.currentProgramId;
      this.$emit("close");
    },
    changeCurrentProgram() {
      this.saving = true;

      let variables = {
        userProgramId: this.programId,
      };

      let key = this.mode === "update" ? "programId" : "nextProgramId";
      variables[key] = this.newProgramId;

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_PROGRAM_MUTATION,
          variables: variables,
        })
        .then((result) => {
          if (!result.data.updateUserProgram.updated) {
            alert(result.data.updateUserProgram.error);
          } else {
            this.$toasted.success("User program updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
          this.saving = false;
          this.close();
          this.$refs.observer.reset();
        })
        .catch((error) => {
          this.saving = false;
        });
    },
  },
  apollo: {
    programs: {
      query: PROGRAMS_QUERY,
      result(response) {
        if (response.data) {
          this.programOptions = response.data.programs.map((item) => {
            return {
              text: item.name,
              value: item.id,
            }
          });
        }
      },
    },
  },
};
</script>

<style scoped>
.short-dropdown {
  max-width: 95px;
  margin-left: 10px;
}
.inline {
  display: inline-flex;
  align-items: center;
  width: 100%;
}
form > .row {
  margin: 0;
}
</style>